export default __webpack_public_path__ + "images/b03e45ec80c491ec3855b44c44d611b6.png";